import React from "react";
import "../LayoutCSS/Christmas.css";

const LightRope = () => {
    // You could optionally generate <li> elements dynamically 
    // if you want a variable number of �globe� lights.
    return (
        <ul className="lightrope">
            {Array.from({ length: 60 }).map((_, i) => (
                <li key={i}></li>
            ))}
        </ul>
    );
};

export default LightRope;
